const notFound = () => {
  return (
    <>
      <h1>Not Found</h1>
    </>
  )
}

export default notFound